import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Plane, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const routes = [
  { from: "Bangkok", fromCode: "BKK", to: "Bali", toCode: "DPS" },
  { from: "Paris", fromCode: "CDG", to: "Bangkok", toCode: "BKK" },
  { from: "London", fromCode: "LHR", to: "New York", toCode: "JFK" },
  { from: "Dubai", fromCode: "DXB", to: "Manila", toCode: "MNL" },
  { from: "Singapore", fromCode: "SIN", to: "Tokyo", toCode: "NRT" },
];

export default function PopularRoutes() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (route) => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 7);
    const dateStr = tomorrow.toISOString().split("T")[0];
    navigate(
      `/search-results?from=${route.fromCode}&to=${route.toCode}&date=${dateStr}&type=one_way&travelers=1`
    );
  };

  return (
    <section className="py-16 px-4 bg-[#f8fafc]" data-testid="popular-routes-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-['Outfit'] text-2xl sm:text-3xl font-bold text-[#1e293b]">
            {t("popular_routes.title")}
          </h2>
          <p className="text-sm text-[#64748b] mt-2">{t("popular_routes.subtitle")}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {routes.map((route, i) => (
            <motion.button
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              onClick={() => handleClick(route)}
              className="bg-white rounded-2xl border border-[#e2e8f0] p-4 text-left hover:border-[#f97316] hover:shadow-md transition-all group"
              data-testid={`popular-route-${route.fromCode}-${route.toCode}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <Plane className="w-3.5 h-3.5 text-[#f97316] -rotate-45" />
                <span className="text-xs font-medium text-[#f97316]">From ${12}</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="text-sm font-semibold text-[#1e293b]">{route.fromCode}</span>
                <ArrowRight className="w-3 h-3 text-[#94a3b8] group-hover:text-[#f97316] transition-colors" />
                <span className="text-sm font-semibold text-[#1e293b]">{route.toCode}</span>
              </div>
              <p className="text-xs text-[#94a3b8] mt-1">{route.from} to {route.to}</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
